<template>
  <div class='ai-disclaimer' :class="{ 'ai-disclaimer-beta': variant === 'beta' }">
    <span class="material-icons-outlined" :class="{'info-icon': !singleLine, 'info-icon-bigger': singleLine}">
      info
    </span>
    <div class="ai-disclaimer-text" v-if="!singleLine && variant === 'default'">
      <p>This feature integrates AI technology.</p>
      <p>
        Always review content to ensure accuracy, relevance, and objectivity.
        <button
          class='link-button'
          @click="handleModalOpen">
          Learn more
        </button>
      </p>
    </div>
    <div class="ai-disclaimer-text" v-if="singleLine && variant === 'default'">
      <p>This feature integrates AI technology. Always review content to ensure accuracy, relevance, and objectivity.
        <button
          class='link-button'
          @click="handleModalOpen">
          Learn more
        </button>
      </p>
    </div>
    <div class="ai-disclaimer-text" v-if="variant === 'beta'">
      <p>This new feature integrates AI technology and is in active development. Review content to ensure accuracy, relevance, and objectivity.
        <button
          class='link-button'
          @click="handleModalOpen">
          Learn more
        </button>
      </p>
    </div>
    <modal v-model="showModal" title="Goalbook and Responsible AI Use">
      <p>
        Goalbook believes that our impact comes from our ability to support what’s been shown again and again in research to be the most important school-based factor in student achievement  – the human teacher.
        This belief remains central to our work as we integrate new AI technologies in Goalbook Toolkit.
      </p>
      <p>We are committed to using AI responsibly in our company and our products. Below are some of the ways we are doing that:</p>

      <ul>
        <li>
          <b>Holistic Approach:</b>
          <span>
            Ensuring that our product is high quality, trustworthy, and aligned to research-based practice has guided our content development, software engineering, and product design processes.
            We’re bringing that same commitment to our use of AI technologies.
          </span>
        </li>

        <li>
          <b>Data Security and Privacy:</b>
          <span>
            Our AI technologies are deployed in our private cloud infrastructure so that your data is kept private and secure and regularly SOC 2 evaluated by a third-party auditor.
          </span>
        </li>

        <li>
          <b>Empowered Educators:</b>
          <span>
            Our goal is to integrate AI in ways that center and empower the human educator, rather than replace them.
          </span>
        </li>

        <li>
          <b>Content Safety and Best Practice:</b>
          <span>
            We regularly evaluate and monitor all our content for cultural responsiveness, bias, and inaccuracies, while also ensuring alignment to research-based best practices.
          </span>
        </li>

        <li>
          <b>Community Engagement:</b>
          <span>
            We are committed to continuous learning and improvement and will closely monitor our application of any new technology.
            We seek dialogue, input, and feedback from a diversity of stakeholders so that we can better understand, design, and deliver our products and services.
          </span>
        </li>
      </ul>

      <template v-slot:footer>
        <button
          @click="() => {showModal = false}"
          class="btn btn-primary">
          OK
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'AIDisclaimer',
  data() {
    return {
      showModal: false
    }
  },
  props: {
    singleLine: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'beta'].includes(value)
    }
  },
  methods: {
    handleModalOpen() {
      this.showModal = true
      this.$sendEvent('Opened AI Disclaimer Modal')
    }
  }
}
</script>

<style scoped lang='less'>
.ai-disclaimer {
  margin-top: var(--spacing-lg);
  display: inline-flex;

  .ai-disclaimer-text {
    display: inline;
  }
}

.ai-disclaimer-beta {
  width: 530px;
  margin-top: 0;

  p {
    display: inline;
    color: #000;
  }

  .link-button {
    display: inline;
    padding: 0;
    margin: 0;
  }
}
.info-icon {
  font-size: 0.875rem;
  margin-right: 0.25rem;
  margin-top: 0.1rem;
}
.info-icon-bigger {
  font-size: 1.15rem;
  margin-right: 0.25rem;
  margin-top: 0.1rem;
}
p {
  font-size: 0.875rem;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.modal-dialog .modal-content {
  padding: 1rem;
}

.modal-body {
  p {
    font-size: 0.875rem;
    margin-bottom: 0.8rem;
  }

  ul {
    padding-left: var(--spacing-3xl);
  }
  li {
    font-size: 0.875rem;

    &:not(:last-child) {
      margin-bottom: var(--spacing-lg);
    }
  }
}
</style>
